import { useSelector } from "react-redux";
import CommonTitle from "../../../components/common/common.title";
import Col from "../../../components/element/col";
import Icon from "../../../components/element/icon";
import Input from "../../../components/element/input";
import Row from "../../../components/element/row";
import Button from "../../../components/element/button";
import Container from "../../../components/element/container";
import { useState } from "react";
import * as Yup from "yup";
import { Form, Formik } from "formik";

export default function ContactUs() {
  const { contactList } = useSelector((state) => state.common);

  const contactForm = {
    name: "",
    email: "",
    contact: "",
    message: "",
  };

  const contactSchema = Yup.object().shape({
    name: Yup.string().required("Name is required"),
    contact: Yup.string()
      .matches(/^(11\d{7,8}|1[0-9]\d{7})$/, "Please enter a valid phone number")
      .required("Contact is required"),
    email: Yup.string()
      .email("Please enter a valid email address")
      .required("Email is required"),
    message: Yup.string().required("Message is required"),
  });

  const sendToWhatsApp = (values) => {
    const { name, email, contact, message } = values;
    const fullMessage = `Name: ${name}\nEmail: ${email}\nContact: +60${contact}\nMessage: ${message}`;
    const encoded = encodeURIComponent(fullMessage);
    const whatsappUrl = `https://wa.me/60126566969?text=${encoded}`;
    window.open(whatsappUrl, "_blank");
  };

  const formList = [
    { label: "Name", name: "name", component: "input" },
    { label: "Email", name: "email", component: "input" },
    { label: "123456789", name: "contact", component: "input" },
    { label: "Leave us a message..", name: "message", component: "textarea" },
  ];

  return (
    <Formik
      initialValues={contactForm}
      validationSchema={contactSchema}
      enableReinitialize={true}
      onSubmit={(values, { setFieldError }) => {
        sendToWhatsApp(values);
      }}
    >
      {({ values, errors, setFieldValue, isValid }) => (
        <Form>
          <Container id="contact-us" className="contact-us">
            <Row className="_row contact-content">
              <Col className="v-flex gap-4">
                <CommonTitle title="Contact Us" subtitle="Need Help?" />
                <p className="_label contact-description">
                  Get in touch with us today — we're here to help with your
                  inquiries, orders, or anything else you need.
                </p>
                <Col className="v-flex gap-4 pt-5 px-3">
                  {contactList.map((contact, i) => (
                    <Row className="_row contact-item" key={i}>
                      <Col className="_col icon-bg">
                        <Icon icon={contact.icon} />
                      </Col>
                      <Col className="v-flex gap-1">
                        <p className="_label contact-title">{contact.tag}</p>
                        <h6 className="_label contact-subtitle">
                          {contact.label}
                        </h6>
                      </Col>
                    </Row>
                  ))}
                </Col>
              </Col>

              <Col>
                <Row className="_row contact-form">
                  {formList.map((form, formIndex) => (
                    <>
                      {form.name === "contact" ? (
                        <Col className="w-100">
                          <Row className="_row phone-frame">
                            <p className="_label phone-code">+60</p>
                            <Input
                              key={formIndex}
                              as={
                                form.component === "textarea"
                                  ? "textarea"
                                  : "input"
                              }
                              name={form.name}
                              // value={formData[form.name]}
                              // onChange={handleChange}
                              placeholder={form.label}
                              className="_input ps-1"
                              invalid={false}
                            />
                          </Row>
                          {errors[form.name] && (
                            <Row className="_label error-message element _errors">
                              {errors[form.name]}
                            </Row>
                          )}
                        </Col>
                      ) : (
                        <Input
                          key={formIndex}
                          as={
                            form.component === "textarea" ? "textarea" : "input"
                          }
                          name={form.name}
                          // value={formData[form.name]}
                          // onChange={handleChange}
                          placeholder={form.label}
                          className={`_input ${
                            form.component === "textarea" ? "mt-4" : ""
                          }`}
                        />
                      )}
                    </>
                  ))}
                </Row>
                <Button className="_button send-message" type="submit">
                  Send Message
                </Button>
              </Col>
            </Row>
            <article className="contact-bg" />
          </Container>
        </Form>
      )}
    </Formik>
  );
}
